/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function ExtractorVideoReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeExtractorVideoAction } action: action de
 *     l'application
 * @return { Reducer }
 */
export const ExtractorVideoReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeExtractorVideoAction) => {
      switch (action.type) {
        case actions.ExtractorVideoActionTypes.EXTRACTORVIDEO_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.ExtractorVideoActionTypes.EXTRACTORVIDEO_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.ExtractorVideoActionTypes.EXTRACTORVIDEO_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/supervision/extractor/home/index.ts